export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Search your delivery address',
      },
      placeholder: 'Enter address to find nearest location',
    },
  },
  toasts: {
    failed_to_load_stores: 'Failed to load stores, please refresh the page',
  },
  errors: {
    no_delivery_companies: 'Delivery not available for this address',
    delivery_not_available: "Unfortunately, we don't offer delivery at the moment",
  },
};
